import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class ImportAPI {
    constructor() {
        this.baseUrl = new URL("import/", apiDataManagerBaseURL);
    }

    uploadProviderData(data) {
        return API.authenticatedRequest({
            url: this.baseUrl,
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: data
        });
    }

    importProviderData(taskId, params) {
        const url = new URL(`importData/${taskId}`, this.baseUrl);
        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.MULTIPART,
            token: authenticationCentral.accessToken,
            body: params
        });
    }

    completeImportProviderData(taskId) {
        const url = new URL(`completeImport/${taskId}`, this.baseUrl);
        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            token: authenticationCentral.accessToken,
        });
    }

    matchProviders(task, data) {
        const url = new URL(`match-providers/${task}`, this.baseUrl);
        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(data)
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/datamanager/ImportAPI.js